/**
 * CommentChat
 */

import Config from '../../Config';
import Util from '../../Util';
import InfiniteScroll from '../chat/InfiniteScrollChat';
import Template from '../Template';
import Loading from '../../Loading';
import CommentReply from './CommentReply';
import CommentHeader from './CommentHeader';
import CommentListWrap from './CommentListWrap';
import Tmpl from 'js-template-string';
import DateFormat from 'date-format-simple';

const dateFormat = new DateFormat( Config.now, {
  'a_few_seconds_ago': Config.L10N.a_few_seconds_ago,
  'seconds_ago': Config.L10N.seconds_ago,
  'a_minute_ago': Config.L10N.a_minute_ago,
  'minutes_ago': Config.L10N.minutes_ago,
  'an_hour_ago': Config.L10N.an_hour_ago,
  'hours_ago': Config.L10N.hours_ago,
  'a_day_ago': Config.L10N.a_day_ago,
  'days_ago': Config.L10N.days_ago,
  'a_month_ago': Config.L10N.a_month_ago,
  'months_ago': Config.L10N.months_ago,
  'a_year_ago': Config.L10N.a_year_ago,
  'years_ago': Config.L10N.years_ago,
}, true);

class CommentChat {
  constructor( node, options ) {

    this.$node = node;

    this.scrollOffset = 50;

    this.mobileImageViewer = '';

    this.reloadSecond = 5000;

    this.isLoaded = false;

    this.isLoading = false;

    this.isSubmit = false;

    this._timer = [];

    this._id = this.$node.attr( 'id' );

    this._writeId = 'contentWrite';

    this.articleId = window.articleId;

    Config.board = ( options.board ) ?
      options.board : Config.board;

    Config.commentMore = ( options.commentAPIUrl ) ?
      options.commentAPIUrl : Config.commentMore;

    Config.comment = ( options.comment ) ?
      options.comment : Config.comment;

    Config.commentWrite = ( options.commentWriteAPIUrl ) ?
      options.commentWriteAPIUrl : Config.commentWrite;

    Config.isBnsApp = ( options.isBnsApp ) ?
      options.isBnsApp : false;

    Config.init = ( options.init ) ?
      options.init : () => {
        // empty function
      };

    jQuery.extend( true, Config, options );

    //comment wrap UI
    this.commentListWrap = new CommentListWrap( this.$node );

    //comment count UI
    this.commentHeader = new CommentHeader( this.$node );

    //scroll Control
    this.infiniteScroll = new InfiniteScroll( ( dir ) => {

      let _id = this.getLastId();
      let _dir = 'AFTER';

      if ( dir === 'up' ) {
        _id = this.getFirstId();
        _dir = 'BEFORE';
      } else {
        this.infiniteScroll.setLoadedComplete();
      }

      if ( !this.isLoading && this.isLoaded && _dir === 'BEFORE' ) {
        this.get( _id, _dir, false );
      }
    });

    this.addEvent();

  }

  timer() {
    this._timer.push( setTimeout( () => {
      const $this = jQuery( '.comment-body' );

      if ( !this.infiniteScroll.isLoading() ) {
        this.clearTimer();

        if ( $this.scrollTop() + $this.innerHeight() >= $this[0].scrollHeight - this.scrollOffset ) {
          //if( ( jQuery( document ).height() - jQuery( window ).height() ) <= $( window ).scrollTop() + this.scrollOffset ){
          this.get( this.getLastId(), 'AFTER', false );
        } else {
          this.get( this.getLastId(), 'AFTER', true );
        }
      }
    }, this.reloadSecond ) );
  }

  clearTimer() {
    for ( let idx = 0, len = this._timer.length; len > idx; idx++ ) {
      clearTimeout( this._timer[ idx ] );
    }

    this._timer = [];
  }

  getTemplateHeight( _$node ) {
    const _$contents = jQuery( '<div></div>' );
    _$contents.append( _$node ).hide();

    jQuery( 'body' ).append( _$contents );
    const _height =  _$contents.height();

    _$contents.remove();
    return _height || 0;
  }

  get( callArticleId, direction, isAuto = false ) {
    this.clearTimer();

    if ( !this.articleId ) {
      return;
    }

    this.isLoading = true;

    const commentUrl = Tmpl.render({
      data: {
        articleId: this.articleId,
        board: Config.board,
        moreDirection: direction,
        commentId: callArticleId,
        size: 50,
      },
      template: Config.commentMore,
    });

    const comment = Util.get( commentUrl );
    comment.then( ( data ) => {

      let header = '';
      let write = '';
      let body = '';
      let wrapComment = '';

      this.clearTimer();

      data.commentList = data.commentList.reverse();

      data = Util.convertCamelCase( data );

      //set comment List UI
      body = this.commentListWrap.setUI( this.templateCommentList( data ) );

      //first loaded
      if ( !this.isLoaded ) {

        //set comment Header UI
        header = this.commentHeader.setUI( data.pageNavigation || data.commentPagination );

        //set comment write textare UI
        write = this.commentWrite( this._writeId, Config.L10N.comment_chat_placeholder );

        wrapComment = Template.comment( body + header + write );

        this.$node.append( wrapComment );

        this.setCommentHeight();

        if ( Config.init ) {
          Config.init();
        }

        setTimeout( () => {
          this.infiniteScroll.start();
          this.infiniteScroll.scrollBottom();
        });

      //second loaded
      } else {
        const $commentThread = jQuery( `#${this._id} .commentThread` );

        //second loaded - after
        if ( direction === 'AFTER' ) {
          $commentThread.append( this.templateCommentList( data ) );

          //written by user
          if ( !isAuto ) {
            this.infiniteScroll.scrollBottom();
          }

          this.infiniteScroll.setLoadedComplete();

          //second loaded - before
        } else {
          const $newNode = jQuery( this.templateCommentList( data ) );

          let _scrollTop = this.getTemplateHeight( $newNode ) || 1;
          _scrollTop = jQuery( '.comment-body' ).outerHeight() + _scrollTop;

          const $tmpNode = jQuery( `<div id="tmpNode" style="height:${ _scrollTop }"></div>` );

          $commentThread.prepend( $tmpNode );

          this.infiniteScroll.loadedEnd( _scrollTop );

          $tmpNode.replaceWith( $newNode );
        }
      }

      //first loaded
      this.isLoaded = true;

      //loading
      this.isLoading = false;

      if ( !data.hasMore && direction === 'BEFORE' ) {
        this.infiniteScroll.stop( 'up' );
      }

      ( !jQuery( '.comment-article' ).length ) ?
        jQuery( '.chatting-none' ).show() :
        jQuery( '.chatting-none' ).hide();

      if ( !this._timer.length && this.articleId ) {
        this.timer();
      }

    }, ( _data ) => {

      this.isLoaded = true;

      this.isLoading = false;

      if ( !this.isLoaded && Config.init ) {
        Config.init();
      }

      if ( !this._timer.length && this.articleId ) {
        this.timer();
      }

      if ( this.infiniteScroll ) {
        this.infiniteScroll.loadedEnd();
      }

      if ( _data.status && _data.status.toString() === '401' ) {
        location.reload();
      }
    });
  }

  write( msg, isTxt = false ) {
    this.submit({
      contents: msg,
    }, isTxt);
  }

  clear() {
    jQuery( `#${this._id} .${this._writeId}` ).val( '' );
  }

  submit( data, isTxt = false ) {

    let _val = data.contents;

    if ( isTxt ) {
      _val = Util.escapeTag( _val );
    }

    if ( _val.length === 0 || !jQuery.trim( _val ) ) {
      this.isSubmit = false;
      return false;
    }

    if ( isTxt && _val.length > 300 ) {
      Config.alert( Config.L10N.comment_placeholder_login_max( Config.commentTextMaxCount ) );
      jQuery( `#${this._id} .${this._writeId}` ).blur();
      this.isSubmit = false;
      return false;
    }

    data.contents = _val;

    const _post = Util.get( Config.commentWrite( {'board': Config.board, articleId: this.articleId} ), 'POST', data );
    _post.then( ( submitData ) => {
      this.clear();
      this.get( this.getLastId(), 'AFTER', false );
      this.isSubmit = false;
    }, ( submitData ) => {
      this.isSubmit = false;
      if ( submitData.status && submitData.status.toString() === '401' ) {
        location.reload();
      }
    });
  }

  setCommentHeight() {
    const _headerH = jQuery( '.agit-header-wrap' ).outerHeight();
    const _formH = jQuery( '.comment-form' ).outerHeight();
    const _height = jQuery( window ).height() - _headerH - _formH;
    jQuery( '.comment-body' ).height( _height );
  }

  addEvent() {
    jQuery( 'body' ).on( 'click', `#${this._id} .fe-image`, ( evt ) => {
      evt.preventDefault();
      this.popView( jQuery( evt.currentTarget ).attr( 'src' ) );
    });

    jQuery( 'body' ).on( 'focus', `#${this._id} .${this._writeId}` , ( evt ) => {
      evt.preventDefault();
      jQuery( `#${this._id} .comment-form` ).addClass( 'is-focus' );
    });

    jQuery( 'body' ).on( 'blur', `#${this._id} .${this._writeId}` , ( evt ) => {
      evt.preventDefault();
      setTimeout( () => {
        jQuery( `#${this._id} .comment-form` ).removeClass( 'is-focus' );
      }, 200 );
    });

    jQuery( 'body' ).on( 'click', '.btn-chat-send', ( evt ) => {
      evt.preventDefault();

      if ( this.isSubmit ) {
        return;
      }

      this.isSubmit = true;

      const val = jQuery( `#${this._id} .${this._writeId}` ).val();
      this.write( val, true );
    });

    jQuery( 'body' ).on( 'keypress', `#${this._id} .${this._writeId}` , ( evt ) => {
      const key = evt.keyCode || evt.which;

      if ( key === 13 ) {
        evt.preventDefault();

        if ( !jQuery( 'body' ).hasClass( 'pc' ) ) {
          return;
        }

        if ( this.isSubmit ) {
          return;
        }

        this.isSubmit = true;

        const _$this = jQuery( `#${this._id} .${this._writeId}` );

        const _val = _$this.val();

        this.write( _val, true );
      }
    });

    jQuery( window ).on( 'resize', ( evt ) => {
      this.setCommentHeight();
    });
  }

  getLastId() {
    return jQuery( `#${this._id} .comment-article` ).last().attr( 'data-commentid' ) || '';
  }

  getFirstId() {
    return jQuery( `#${this._id} .comment-article` ).first().attr( 'data-commentid' ) || '';
  }

  appendTmpImageTemplate( _data ) {
    return Template.render({
      data: '',
      template: ( data ) => `
      <div></div>
      <div id="fe-tmp-image" contenteditable="false" style="position:relative;width:100%;height:200px;background-color:#f4f5f7;border:solid 1px #efefef;">
      <div class="ncCommunityLoader nc-community-loader" style="display:block;top:85px;">
      <div class="loader-circle"></div>
      </div>
      </div>
      <div></div>`,
    });
  }

  templateCommentList( _data /* ,timeMsg = '' */ ) {
    return Tmpl.iterate({
      data: _data.commentList,
      template: ( _v ) => `
        <div class="comment-article
        ${ ( _v.writer.loginUser.uid === Config.guid ) ? ` is-send` : ` is-receive`}" data-commentid="${_v.commentId}">
        <div class="comment-info">
        <i class="fe-icon-reply"></i>
        <!--span class="thumb">
        <img src="http://dn.sfile.plaync.com/data/${_v.writer.loginUser.uid}/profile?type=small" alt="">
        </span-->
        <span class="writer">${ _v.writer.loginUser.name }</span>
        <span class="date">${ dateFormat.printFull( _v.postDate ).substr( 6 ).substring( 0, 12 ).replace( /\s/, '').replace( /\s/, '. ' ) }</span>
        </div>
        <div class="comment-contents${ ( _v.contents.indexOf( '<img') !== -1 ) ? ` emoticon` : ''}">${ _v.contents }</div>
        </div>`,
    });
  }

  commentWrite( content, placeHolder = '' ) {
    return `<div class="comment-form">
    <div class="comment-form-textarea">
    <textarea class="content ${content}" name="content" placeholder="${placeHolder}"></textarea>
    </div>
    </div>`;
  }

  popView( src ) {
    if ( !this.mobileImageViewer ) {
      if ( window.nc && window.nc.ui && window.nc.ui.ImageViewer ) {
        this.mobileImageViewer = new nc.ui.ImageViewer( jQuery( 'body' ), [src], { commentUrl: '' } );
      }

      this.mobileImageViewer.slideByUrl( src );

      return;
    }

    this.mobileImageViewer.setImages( [ src ] );
    this.mobileImageViewer.show();
  }
}

export default CommentChat;
